/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Benefits_Item5Inputs */

const ja_playdata_home_benefits_item5 = /** @type {(inputs: Playdata_Home_Benefits_Item5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同一・類似タイトルのイベント人気度を比較したい`)
};

const en_playdata_home_benefits_item5 = /** @type {(inputs: Playdata_Home_Benefits_Item5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to compare popularity of events with the same or similar games`)
};

/**
* | output |
* | --- |
* | "I want to compare popularity of events with the same or similar games" |
*
* @param {Playdata_Home_Benefits_Item5Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_benefits_item5 = /** @type {((inputs?: Playdata_Home_Benefits_Item5Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Benefits_Item5Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_benefits_item5(inputs)
	return en_playdata_home_benefits_item5(inputs)
});